<template>
    <div>
        <v-container>
            <v-row>
                <v-col><h1>{{ form.title }}</h1></v-col>
                <v-col cols="2"><v-btn color="addStuff" height="30" tile block @click="clickBack()">Tillbaka</v-btn></v-col>
            </v-row>
        </v-container>
        <v-container v-if="customFields">
            <template v-for="(field,index) in customFields">
                <template v-if="field.type == 'HEADER'">
                    <v-row :key="index" class="header-row">
                        <v-col>{{ field.value }}</v-col>
                    </v-row>
                </template>
                <template v-else-if="index % 2 == 0">
                    <v-row :key="index">
                        <v-col class="label">{{ field.label }}</v-col>  
                        <template v-if="field.type && field.type == 'CHECKBOX'">
                            <template v-if="field.value == 'true'">
                                <v-col><input type="checkbox" disabled checked></v-col>
                            </template>
                            <template v-else>
                                <v-col><input type="checkbox" disabled></v-col>
                            </template>
                        </template>
                        <template v-else>
                            <v-col v-if="field.value && field.value.includes('|')"></v-col>
                            <v-col v-else>{{ field.value }}</v-col>
                        </template>
                        <v-spacer></v-spacer>
                        <template v-if="customFields[index+1]">
                            <template  v-if="customFields[index+1] && customFields[index+1].type == 'CHECKBOX'">
                                <v-col class="label">{{ customFields[index+1].label }}</v-col>
                                <template v-if="customFields[index+1].value == 'true'">
                                    <v-col><input type="checkbox" disabled checked></v-col>
                                </template>
                                <template v-else>
                                    <v-col><input type="checkbox" disabled></v-col>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="customFields[index+1].type == 'HEADER'">
                                    <v-col></v-col>
                                    <v-col></v-col>
                                </template>
                                <template v-else>
                                    <v-col class="label">{{ customFields[index+1].label }}</v-col>
                                    <v-col v-if="customFields[index+1].value && customFields[index+1].value.includes('|')"></v-col>
                                    <v-col>{{ customFields[index+1].value }}</v-col>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <v-col class="label"></v-col>
                            <v-col></v-col>
                        </template>
                    </v-row>
                </template>
            </template>
        </v-container>
    </div>
</template>

<script>
export default {
    'name': 'FormDetails',
    props: ['formId'],
    mounted() {
        this.fetchForm();
    },
    data: () => ({
        form: {}
    }),
    methods: {
        fetchForm() {
            this.$api.get('get_form/' + this.formId)
                .then(response => {
                    this.form = response.data;
                }, this)
                .catch( error => {
                    console.error('could not fetch form: ' + error);
                    //this.snack('could not fetch form: ' + error);
                }, this)
                .finally(() => {
                    //this.loading = false;
                }, this);
        },
        clickBack() {
            this.$router.go(-1);
        }
    },
    computed: {
        state() {
            return 'TODO translate state';
        },
        customFields() {
            if (this.form && this.form.fields) {
                let customFields = JSON.parse(JSON.stringify(this.form.fields));
                if (customFields) {
                    customFields.forEach(field => {
                        if (field && field.type == 'OK_ACTION_NOTE') {
                            let value = '';
                            if (field.value.indexOf('ok') == 0) value += 'OK';
                            if (field.value.includes('action')) value += ' Åtgärd';
                            if (field.value.includes('|')) {
                                value += ': ' + field.value.split('|')[1];
                            }
                            field.value = value;
                        }
                    });
                }
                return customFields;
            }
            return [];
        }
    }
}
</script>

<style lang="scss" scoped>
    .label {
        color: grey;
        text-align: right;
    }
</style>